// removed by extract-text-webpack-plugin
module.exports = {"receipt-counting-box":"app-components-receipt-invoices-CountingBox-__CountingBox___2N0V7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/invoices/CountingBox/CountingBox.css
// module id = 750
// module chunks = 0